// components/common/SkeletonMenuItem.js
import React from "react";

const SkeletonMenuItem = () => {
  return (
    <li className="skeleton-menu-item">
      <div className="skeleton-nav-wrap"></div>
    </li>
  );
};

export default SkeletonMenuItem;
